/* eslint-disable consistent-return */

import { sync } from 'vuex-pathify';

export default {

  data() {
    return {
      state: '',
    };
  },

  computed: {
    ...sync([
      'action/target', //
    ]),

  },

  methods: {
    hideModal() {
      this.$root.$emit('bv::hide::modal', this.modalId);
    },

    // hideAllModals() {
    //   Bus.$emit('modals:hide-all');
    // },
  },
};
